const $ = window.jQuery;
const $window = window.$window || $(window);

const VideoPlayer = {
    init() {
        var $module = $("#video");
        if (!$module.length) return;

        $module.each((index, element) => {
            this.each(element);
        });
    },

    each(element) {
        var $videoSrc
        $('.video-cover').click(function () {
            $videoSrc = $('.video-file').data('src')
            console.log($videoSrc)
            $('.video-cover').fadeOut();
            $('.video-file').addClass('is-active')
            $('#video').attr(
                'src',
                $videoSrc + '?autoplay=1&amp;modestbranding=1&amp;showinfo=0'
            )
            $(this).fadeOut();
        })
    },
};

export default VideoPlayer;
